import { Helmet } from 'react-helmet-async';

export const WebSiteSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "RSA Tech Group",
    "alternateName": "RSA Technology",
    "url": "https://rsatech.com",
    "description": "Cognitive Enterprise Solutions - AI at the Core. Scale at Speed.",
    "publisher": {
      "@type": "Organization",
      "name": "RSA Tech Group",
      "logo": {
        "@type": "ImageObject",
        "url": "https://rsatech.com/rsa-favicon.png"
      }
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://rsatech.com/search?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
